"use client";

import { useState } from "react";
import { ArrowLeft, Check } from "lucide-react";
import BackLink from "../components/ui/BackLink";

import { Link } from "react-router";
import NavBar from "../components/common/NavBar";

export default function Test() {
  const [billingCycle, setBillingCycle] = useState("monthly");

  const handlePaystackPayment = (plan) => {
    // In a real implementation, you would redirect to Paystack or initialize their popup
    alert(`Redirecting to Paystack payment gateway for ${plan} plan...`);
  };

  return (
    <div className="min-h-screen bg-base-100">
      <NavBar className="z-50" />

      <div className="container mx-auto py-12 px-4">
        <BackLink text="Back to Home" className="btn-sm gap-2 mb-6" />

        <div className="text-center max-w-2xl mx-auto mb-10">
          <h1 className="text-4xl font-bold mb-3">Find the Perfect Plan</h1>
          <p className="text-lg">We are here to help you achieve academic excellence</p>
        </div>

        {/* Billing toggle */}
        <div className="flex justify-center mb-10">
          <div className="bg-base-200 rounded-full p-1 inline-flex">
            <button
              className={`px-6 py-2 rounded-full ${
                billingCycle === "monthly" ? "bg-primary text-primary-content" : ""
              }`}
              onClick={() => setBillingCycle("monthly")}
            >
              Monthly
            </button>
            <button
              className={`px-6 py-2 rounded-full ${
                billingCycle === "yearly" ? "bg-primary text-primary-content" : ""
              }`}
              onClick={() => setBillingCycle("yearly")}
            >
              Yearly
              {billingCycle === "yearly" && (
                <span className="ml-2 bg-success text-success-content text-xs px-2 py-0.5 rounded-full">
                  Save 10%
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Pricing cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {/* Basic Plan */}
          <div className="bg-base-100 rounded-xl p-8 shadow-md border border-base-200">
            <div className="mb-4">
              <h2 className="text-2xl font-bold">Basic</h2>
            </div>

            <div className="mb-6">
              <span className="text-5xl font-bold">₦2,000</span>
              <span className="text-base-content/70"> / month</span>
            </div>

            <div className="divider my-6"></div>

            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>200+ Practice Tests</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>Basic Study Materials</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>Progress Tracking</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>Mobile Access</span>
              </li>
            </ul>

            <button
              className="btn btn-outline btn-primary w-full mt-8"
              onClick={() => handlePaystackPayment("Basic")}
            >
              Get Started
            </button>
          </div>

          {/* Premium Plan */}
          <div className="bg-base-100 rounded-xl p-8 shadow-md border border-primary relative">
            {/* Popular badge */}
            <div className="absolute top-0 right-0 bg-primary text-primary-content py-1 px-4 rounded-br-xl rounded-tl-xl font-medium">
              Most Popular
            </div>

            <div className="mb-4">
              <h2 className="text-2xl font-bold">Premium</h2>
            </div>

            <div className="mb-6">
              <span className="text-5xl font-bold">₦3,000</span>
              <span className="text-base-content/70"> / month</span>
            </div>

            <div className="divider my-6"></div>

            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>500+ Practice Tests</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>Comprehensive Study Materials</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>Personalized Learning Paths</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>Performance Analytics</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>Dedicated Coach Support</span>
              </li>
              <li className="flex items-center gap-3">
                <Check className="size-5 text-primary" />
                <span>Step-by-Step Guides</span>
              </li>
            </ul>

            <button
              className="btn btn-primary w-full mt-8"
              onClick={() => handlePaystackPayment("Premium")}
            >
              Subscribe Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
